import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

pageContainerStyles.container = {
    css: css`
        margin-bottom: 104px;
        & > div {
            width: calc(100% + 30px) !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-bottom: 52px;
                `,
                css`
                    margin-bottom: 52px;
                `,
                css`
                    margin-bottom: 75px;
                `,
                null,
                null,
            ])}
    `,
};
